/* tslint:disable */
/* eslint-disable */
/**
 * LWM portal
 * Lamb-Weston Meijer Portal API documentation
 *
 * The version of the OpenAPI document: 3.3.11
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * HTTP methods and descriptions  Methods from the following RFCs are all observed:      * RFC 7231: Hypertext Transfer Protocol (HTTP/1.1), obsoletes 2616     * RFC 5789: PATCH Method for HTTP
 * @export
 * @enum {string}
 */

export enum HTTPMethod {
    Connect = 'CONNECT',
    Delete = 'DELETE',
    Get = 'GET',
    Head = 'HEAD',
    Options = 'OPTIONS',
    Patch = 'PATCH',
    Post = 'POST',
    Put = 'PUT',
    Trace = 'TRACE'
}



